import { customFonts } from '../../../../styles';
import { makeStyles } from '@fluentui/react-components';
import CapabilitiesCard from './CapabilitiesCard';
import FAQsCard from './FAQsCard';
import KnowledgeSourceCard from './KnowledgeSourcesCard';
import AgentOwnersCard from './AgentOwnersCard';
import { NexusAgent } from '../../../../domain/agents/models/Agent';
import RelatedLinks from './RelatedLinksCard';

const useStyles = makeStyles({
    main: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        fontFamily: customFonts.Lato,
        gap: '35px',
        maxWidth: '925px',
    },
    leftColumn: {
        flex: 5,
        display: 'flex',
        flexDirection: 'column',
        gap: '30px',
    },
    rightColumn: {
        flex: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: '30px',
    },
});

interface AgentOverviewContentProps {
    agent: NexusAgent | null;
}

const AgentOverviewContent: React.FC<AgentOverviewContentProps> = ({ agent }) => {
    const styles = useStyles();

    return (
        <main className={styles.main}>
            <div className={styles.leftColumn}>
                <CapabilitiesCard capabilities={agent?.capabilities} />
                {agent?.faqs && agent.faqs.length > 0 && <FAQsCard faqs={agent?.faqs} />}
            </div>
            <div className={styles.rightColumn}>
                <AgentOwnersCard ownersInfo={agent?.ownerInfo} ownersBlurb={agent?.ownerBlurb} />
                {agent?.knowledgeBase && <KnowledgeSourceCard knowledgeSources={agent?.knowledgeBase} />}

                {agent?.relatedLinks && agent.relatedLinks.length > 0 && (
                    <RelatedLinks relatedLinks={agent?.relatedLinks} />
                )}
            </div>
        </main>
    );
};

export default AgentOverviewContent;
